import { render, staticRenderFns } from "./ManageGeneralCertificate.vue?vue&type=template&id=0574c314&scoped=true&"
import script from "./ManageGeneralCertificate.vue?vue&type=script&lang=js&"
export * from "./ManageGeneralCertificate.vue?vue&type=script&lang=js&"
import style0 from "./ManageGeneralCertificate.vue?vue&type=style&index=0&id=0574c314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0574c314",
  null
  
)

export default component.exports